import GiftAnArticleButtonDefault from "@features/giftAnArticle/components/GiftAnArticleButton/GiftAnArticleButtonDefault";
import GiftAnArticleButtonVersion2 from "@features/giftAnArticle/components/GiftAnArticleButton/GiftAnArticleButtonVersion2";
import GiftAnArticleButtonVersion3 from "@features/giftAnArticle/components/GiftAnArticleButton/GiftAnArticleButtonVersion3";
import GiftAnArticleButtonVersion4 from "@features/giftAnArticle/components/GiftAnArticleButton/GiftAnArticleButtonVersion4";

import { GiftAnArticleVersion } from "./types";

export const GiftAnArticleButonFactory = ({
  giftAnArticleVersion = GiftAnArticleVersion.default,
}) => {
  switch (giftAnArticleVersion) {
    case GiftAnArticleVersion.version2:
      return GiftAnArticleButtonVersion2;

    case GiftAnArticleVersion.version3:
      return GiftAnArticleButtonVersion3;

    case GiftAnArticleVersion.version4:
      return GiftAnArticleButtonVersion4;

    default:
      return GiftAnArticleButtonDefault;
  }
};
